import React, {Component} from 'react';
import ReactModal from 'react-modal';
import {connect} from "react-redux";
import PersonalPropertyApi from "../../../api/PersonalProperty";

class ExportToExistingListingModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userId: '',
            listingId: '',
            synchronizationCategory: 'EVERYTHING'
        }
    }

    handleInputChange(event) {
        const newState = {};
        newState[event.target.name] = event.target.value;

        this.setState(newState);
    }

    onClose(event) {
        event.preventDefault();

        this.props.onClose();
    }

    addAirbnbExport(event) {
        event.preventDefault();
        PersonalPropertyApi.addAirbnbExportExisting(this.props.propertyId, this.state.userId, this.state.listingId, this.state.synchronizationCategory).then(() => {
            this.props.onClose();
        })
    }

    render() {
        return (
            <ReactModal
                className="custom-react-modal external-calendars-modal"
                isOpen={this.props.isOpen}
                overlayClassName="custom-react-modal-overlay"
            >
                <form className="light">
                    <div className="external-calendars-modal_close">
                        <i className="fa fa-close" onClick={::this.onClose}/>
                    </div>

                    <div className="external-calendars-modal_title">
                        Add Syncing with Existing Listing
                    </div>

                    <div className="external-calendars-modal_form">
                        <label>
                            Airbnb UserId:
                            <input
                                name="userId"
                                value={this.state.userId}
                                onChange={::this.handleInputChange}
                                ref={input => {
                                    this.name = input;
                                }}
                            />
                        </label>

                        <label>
                            Listing Id:
                            <input
                                name="listingId"
                                value={this.state.listingId}
                                onChange={::this.handleInputChange}
                                ref={input => {
                                    this.name = input;
                                }}
                            />
                        </label>

                        <label>
                            Synchronization Category:
                            <select
                                value={this.state.synchronizationCategory}
                                onChange={::this.handleInputChange}
                                name='synchronizationCategory'
                            >
                                <option key='EVERYTHING' value='sync_all'>Sync FULL</option>
                                <option key='LIMITED' value='sync_rates_and_availability'>Sync Calendars And Rated only</option>
                            </select>
                        </label>
                    </div>

                    <br/>
                    <button className="btn" onClick={::this.addAirbnbExport}>
                        Do Sync
                    </button>
                </form>
            </ReactModal>
        )
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ExportToExistingListingModal);


// WEBPACK FOOTER //
// ./src/components/CreatingProperty/airbnbCm/ExportToExistingListingModal.js